import ShareApp from './ShareApp';

export default ShareApp;
